<template>
  <div class="html">
    <div class="top">
      <div class="h30">
        <div class="w1200">
          <div class="fr">
            <span style="cursor: pointer" @click="getHelp"
              ><i class="el-icon-question"></i>帮助中心&nbsp;&nbsp;&nbsp;
            </span>
            <span
              ><i class="el-icon-user-solid"></i>你好,{{
                user.userName
              }}&nbsp;&nbsp;&nbsp;
            </span>
            <router-link
              v-if="
                userModule.role == 'Admin' ||
                userModule.role == 'AreaManager' ||
                userModule.role == 'SchoolManager' ||
                userModule.role == 'Auditor'
              "
              :to="{
                name:
                  userModule.role == 'AreaManager'||userModule.role == 'Admin'
                    ? 'manageRole'
                    : userModule.role == 'SchoolManager'
                    ? 'managePrinter'
                    : 'manageExamine',
              }"
              >后台管理</router-link
            >
            <!-- <span>切换角色</span> -->
            <span @click="logout" style="cursor: pointer">退出登录</span>
          </div>
        </div>
      </div>
    </div>
    <router-view :currentdirectory="currentdirectory"></router-view>
    <div class="footer">
      <div class="w1200">
        <span class="copyright"
          >Copyright © {{ new Date().getFullYear() }} 长水教育集团
          <router-link to="/edition" v-if="configure.edition[0]"
            >当前版本：{{ configure.edition[0].id }}</router-link
          ></span
        >
      </div>
    </div>
  </div>
</template>


<script>
import emitter from "../mixins/emitter";
import { mapState } from "vuex";
export default {
  name: "Layout",
  data() {
    return {
      user: { roles: {}, role: null },
      // 切换角色开始
      roleDialog: false,
      roleId: "",
      currentdirectory: {},
      loading: "",
    };
  },
  mixins: [emitter],
  computed: {
    ...mapState(["userModule"]),
    ...mapState(["configure"]),
  },
  methods: {
    getHelp() {
      let url = "http://wiki.hwxxkj.com:8089/docs/show/962";
      window.open(url, "_blank");
    },
    logout: function () {
      // let url = "/api/logout";
      // let param = {
      //   loginType: "Server",
      // };
      // this.$confirm("确定要退出吗?", "提示").then(() => {
      //   this.$ajax.post(url, param).then((data) => {});
      // });
      let userAgent = navigator.userAgent;
      if (
        userAgent.indexOf("Firefox") != -1 ||
        userAgent.indexOf("Chrome") != -1
      ) {
        window.location.href = "about:blank";
        window.close();
      } else {
        window.opener = null;
        window.open("", "_self");
        window.close();
      }
    },
    async getUserInfo() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      //1.获取用户信息
      let data = await this.$ajax.post("/common/load/user");

      let sectionData;
      let currentDirectory;
      let breadcrumb;
      this.$ajax.get("/configure/configure.json").then((res) => {
        this.$store.commit("saveconfigure", res);
      });
      if (!JSON.parse(window.sessionStorage.getItem("sectionData"))) {
        sectionData = await this.$ajax.post(
          "/common/catalog/load/catalog/tree",
          {}
        );

        window.sessionStorage.setItem(
          "sectionData",
          JSON.stringify(sectionData)
        );
      } else {
        sectionData = JSON.parse(window.sessionStorage.getItem("sectionData"));
      }
      if (sectionData.length == 0) {
        if (
          data.user.roleList.filter((el) => el.id == "AreaManager").length > 0
        ) {
          let map = data.user;
          window.sessionStorage.setItem("clientId", data.clientId);
          window.sessionStorage.setItem("token", data.token);
          window.sessionStorage.setItem("uploadUrl", data.uploadUrl);
          window.sessionStorage.setItem("fileJavaServerUrl", data.fileJavaServerUrl);
          // window.sessionStorage.setItem(
          //   "uploadUrl",
          //   "http://192.168.0.132:44314"
          // );
          window.sessionStorage.setItem("previewUrl", data.previewUrl);
          window.sessionStorage.setItem("schoolId", data.user.schoolId);
          window.sessionStorage.setItem("schoolName", data.user.schoolName);
          this.user = {
            id: map.id,
            loginName: map.loginName,
            sex: map.sex,
            userName: map.userName,
            roles: map.roleList,
            role:
              map.roleList.filter((el) => el.roleCode == "SchoolManager")
                .length > 0
                ? "SchoolManager"
                : map.roleList[0].roleCode,
            cityId: map.cityId,
            areaId: map.areaId,
            schoolId: map.schoolId,
            schoolName: map.schoolName,
            gradeId: map.gradeId,
            classId: map.classId,
            userType: map.userType,
            clientId: data.clientId,
            token: data.token,
            previewUrl: data.previewUrl,
            uploadUrl: data.uploadUrl,
          };
          window.sessionStorage.setItem("role", this.user.role);
          this.saveStore(this.user);
          this.$router.push({ name: "manageSync" });
          return false;
        } else {
          this.$message.error("目录未同步，请联系管理员");
          return false;
        }
      } else {
        if (!JSON.parse(window.sessionStorage.getItem("currentDirectory"))) {
          currentDirectory = await this.$ajax.post(
            "/common/load/teacher/course"
          );
          //没有任课
          if (!currentDirectory.sectionId) {
            currentDirectory = {
              sectionId: sectionData[0].id,
              sectionName: sectionData[0].label,
              subjectId: sectionData[0].children[0].id,
              subjectName: sectionData[0].children[0].label,
            };
          } else {
            //有任课且任课可匹配
            if (
              sectionData.filter((el) => el.id == currentDirectory.sectionId)
                .length > 0 &&
              sectionData
                .filter((el) => el.id == currentDirectory.sectionId)[0]
                .children.filter((el) => el.id == currentDirectory.subjectId)
                .length > 0
            ) {
              currentDirectory = {
                sectionName: sectionData.filter(
                  (el) => el.id == currentDirectory.sectionId
                )[0].label,
                sectionId: sectionData.filter(
                  (el) => el.id == currentDirectory.sectionId
                )[0].id,
                subjectName: sectionData
                  .filter((el) => el.id == currentDirectory.sectionId)[0]
                  .children.filter(
                    (el) => el.id == currentDirectory.subjectId
                  )[0].label,
                subjectId: sectionData
                  .filter((el) => el.id == currentDirectory.sectionId)[0]
                  .children.filter(
                    (el) => el.id == currentDirectory.subjectId
                  )[0].id,
              };
            } else {
              //有任课且任课无匹配
              currentDirectory = {
                sectionId: sectionData[0].id,
                sectionName: sectionData[0].label,
                subjectId: sectionData[0].children[0].id,
                subjectName: sectionData[0].children[0].label,
              };
            }
          }
        } else {
          let map = data.user;
          window.sessionStorage.setItem("clientId", data.clientId);
          window.sessionStorage.setItem("token", data.token);
          window.sessionStorage.setItem("uploadUrl", data.uploadUrl);
          window.sessionStorage.setItem("fileJavaServerUrl", data.fileJavaServerUrl);
          // window.sessionStorage.setItem(
          //   "uploadUrl",
          //   "http://192.168.0.132:44314"
          // );
          window.sessionStorage.setItem("previewUrl", data.previewUrl);
          window.sessionStorage.setItem("schoolId", data.user.schoolId);
          window.sessionStorage.setItem("schoolName", data.user.schoolName);
          this.user = {
            id: map.id,
            loginName: map.loginName,
            sex: map.sex,
            userName: map.userName,
            roles: map.roleList,
            role:
              map.roleList.filter((el) => el.roleCode == "SchoolManager")
                .length > 0
                ? "SchoolManager"
                : map.roleList[0].roleCode,
            cityId: map.cityId,
            areaId: map.areaId,
            schoolId: map.schoolId,
            schoolName: map.schoolName,
            gradeId: map.gradeId,
            classId: map.classId,
            userType: map.userType,
            clientId: data.clientId,
            token: data.token,
            previewUrl: data.previewUrl,
            uploadUrl: data.uploadUrl,
          };
          window.sessionStorage.setItem("role", this.user.role);
          this.saveStore(this.user);
          currentDirectory = JSON.parse(
            window.sessionStorage.getItem("currentDirectory")
          );
        }
        breadcrumb = [
          "资源平台",
          currentDirectory.sectionName + currentDirectory.subjectName,
        ];
        if (currentDirectory.versionName) {
          breadcrumb.push(currentDirectory.versionName);
        }
        window.sessionStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));
        window.sessionStorage.setItem(
          "currentDirectory",
          JSON.stringify(currentDirectory)
        );
        this.currentdirectory = currentDirectory;
        let map = data.user;
        window.sessionStorage.setItem("clientId", data.clientId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("uploadUrl", data.uploadUrl);
        window.sessionStorage.setItem("fileJavaServerUrl", data.fileJavaServerUrl);
        // window.sessionStorage.setItem(
        //   "uploadUrl",
        //   "http://192.168.0.132:44314"
        // );
        window.sessionStorage.setItem("previewUrl", data.previewUrl);
        window.sessionStorage.setItem("schoolId", data.user.schoolId);
        window.sessionStorage.setItem("schoolName", data.user.schoolName);
        this.user = {
          id: map.id,
          loginName: map.loginName,
          sex: map.sex,
          userName: map.userName,
          roles: map.roleList,
          role:
            map.roleList.filter((el) => el.roleCode == "SchoolManager").length >
            0
              ? "SchoolManager"
              : map.roleList[0].roleCode,
          cityId: map.cityId,
          areaId: map.areaId,
          schoolId: map.schoolId,
          schoolName: map.schoolName,
          gradeId: map.gradeId,
          classId: map.classId,
          userType: map.userType,
          clientId: data.clientId,
          token: data.token,
          previewUrl: data.previewUrl,
          uploadUrl: data.uploadUrl,
        };
        window.sessionStorage.setItem("role", this.user.role);
        this.saveStore(this.user);
      }

      // this.broadcast("index", "getCurrent", sectionData);
      // this.$store.commit("saveCurrentDirectory", currentDirectory);
      // this.$store.commit("saveBreadcrumb", breadcrumb);
      // this.$store.commit("saveSectionData", sectionData);

      // if (!window.sessionStorage.getItem("currentDirectory")) {
      //   await this.$ajax.post("/common/load/teacher/course").then((res) => {
      //     if (res.sectionId) {
      //       if (window.sessionStorage.getItem("sectionData")) {
      //         this.$ajax
      //           .post("/common/catalog/load/section/subject")
      //           .then((res) => {});
      //       }

      //       window.sessionStorage.setItem("currentDirectory", res);
      //     }
      //   });
      // }
    },
    saveStore(a) {
      a.isLogin = true;
      // 获取教师角色权限下放列表
      this.teacherRoleDown = a.authPowerStrList;
      this.$store.commit("saveuser", a);
      this.loading.close();
    },
    //================ 切换角色开始===================
    roleSelection(id) {
      //选择角色
      this.$ajax.post("/api/web/base/save/role", { role: id }).then((data) => {
        this.user.role = id;
        this.roleDialog = false;
        this.saveStore(this.user);
      });
    },
    roleClose() {
      if (this.user.role) {
        this.roleDialog = false;
      } else {
        this.hw_warn("请选择角色!");
      }
    },
  },
  created: function () {
    this.getUserInfo();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/Layout.vue